import { Link } from '@tanstack/react-router';
import { Typography } from '@volvo/vcdk-react';
import React from 'react';
import { isMobile } from 'react-device-detect';

import type { IAftermarketCampaign } from '@/service/vpc/types/IAftermarketCampaign';
import type { IIndividualProduct } from '@/service/vpc/types/IIndividualProducts';
import type { IUnit } from '@/service/vpc/types/IUnit';

import InstallAvailableButton from '@/components/remote-software/components/InstallAvailableButton';
import { rsdwl } from '@/utils';

type Props = {
  row: {
    data: IAftermarketCampaign;
    units: IUnit[];
    products: (IIndividualProduct | undefined)[];
  };
};

const CampaignUnitsDetails: React.FC<Props> = ({ row }) => {
  // const uniqueProducts = product.getDesignationsWithCount(products);
  const campaign = row.data;
  const showWebInstallButton = rsdwl.showWebInstallButton(campaign);

  return (
    <div className="flex max-w-sm flex-col gap-4 py-5">
      {row.units.map((unit) => (
        <div key={unit.endCustomerUnitId} className="flex items-center justify-between gap-5">
          <Link
            to="/units/$endCustomerUnitId/campaigns"
            params={{ endCustomerUnitId: String(unit.endCustomerUnitId) }}
            className="block hover:underline"
          >
            <Typography variant="subtitle1">{unit.unitName}</Typography>-
            <Typography>{row.products.map((product) => product?.productDesignation).join(', ')}</Typography>
          </Link>
          {showWebInstallButton ? (
            isMobile ? (
              <InstallAvailableButton
                unitName={unit.unitName}
                endCustomerUnitId={unit.endCustomerUnitId}
                campaign={row.data}
              />
            ) : (
              <></>
            )
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default CampaignUnitsDetails;
